import _ from 'underscore';
import { InvalidateStrategy } from './base';

const CONTEXT_KEY = 'cascadeInvalidateStrategyContext';

export class CascadeInvalidateStrategy extends InvalidateStrategy {
  /**
   * Invalidate the cache for resources following the dependant tree
   * @param {Object} options -
   * @param {Object.<string, string[]>} options.dependants -
   *    The dependant tree. It's an object with the keys being the resoures, and
   *    the values their dependants.
   */
  constructor({ dependants }) {
    super();
    this.dependants = dependants;
  }

  /* eslint no-param-reassign: ["error", { "props": false }] */

  /**
   * Handler for the afterInvalidate notification. Continue invalidate more
   * resources following the dependant tree
   * @override
   * @param {JSDataCacheManager} cacheManager - The subject of the notification
   * @param {string} resource - The resource being invalidated
   * @param {string} isTriggeredFromOutside - Indicate whether the invalidate is from outside
   * @returns {void}
   */
  afterInvalidate(cacheManager, resource, isTriggeredFromOutside) {
    const isCascaded = _.has(cacheManager, CONTEXT_KEY);

    if (!isCascaded) {
      cacheManager[CONTEXT_KEY] = {};
    }

    // Put a context object into the cache manager to mark which resources are
    // already invaliated. Prevent infinite recursion caused by circular
    // dependencies
    const context = cacheManager[CONTEXT_KEY];

    context[resource] = true;

    _.chain(this.dependants)
      .result(resource, [])
      .each((dependant) => {
        if (!_.has(context, dependant)) {
          cacheManager.invalidate(dependant, isTriggeredFromOutside);
        }
      })
      .value();

    if (!isCascaded) {
      delete cacheManager[CONTEXT_KEY];
    }
  }
}
